export class ListSecurityFindingsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "SecurityFindingsFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSecurityFindingsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
